import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../NewComponents/Page-3/Layout/style.css";
import { TAX_PERCENT, calcTaxAmount } from "../../utils/tax";
import { getGuestPrepaymentPercent } from "../../utils/prepayment";

const CheckoutDetails = ({
  adultsCount,
  childrenCount,
  bedrooms,
  price,
  price_per_extra_person,
  tax,
  breakfast,
  lunch,
  dinner,
  area,
  adults,
  setAdults,
  children,
  setChildren,
  startDate,
  endDate,
  villaData,
  availability,
}) => {
  const navigate = useNavigate();
  // //console.log("Ye raha Data", villaData);
  const includedPax = adultsCount + childrenCount / 2;
  const maxPax = villaData.number_of_adults + Math.ceil((villaData.number_of_children)/2);
  const activeClass =
    "bg-black text-white rounded-xl  mx-2 px-2 w-6 h-6 text-center hover:cursor-pointer";
  const disableClass =
    "opacity-70 bg-black text-white rounded-xl mx-2 px-2 w-6 h-6 text-center hover:cursor-pointer";

  const [extraPrice, setExtraPrice] = useState(price);
  const [bedroomsState,setBedroomsState]=useState([])
  const [pax, setPax] = useState(adults + Math.ceil(children / 2));

  useEffect(() => {
    setPax(adults + Math.ceil(children / 2));
    if (includedPax >= adults + Math.ceil(children / 2)) setExtraPrice(0);
    else
      setExtraPrice(
        (adults + Math.ceil(children / 2) - includedPax) *
          price_per_extra_person
      );
  }, [adults, children]);

  let thumbnailId = -1;
  if (villaData.main_media_id) thumbnailId = villaData.main_media_id;
  else if (villaData.media_order.length > 0)
    thumbnailId = villaData.media_order[0];
  else if (villaData.media.length > 0)
    thumbnailId = villaData.media[0].mediafiles_id;

  const thumbnail = villaData.media.filter((item) => {
    return thumbnailId === item.mediafiles_id;
  });

  const handleBookNow = () => {
    const bookingData = {
      adults: adults,
      children: children,
      price: price + extraPrice,
      checkIn: startDate,
      checkOut: endDate,
      villaName: villaData.property_name,
      villa_lat: villaData.geo_lat,
      host_id: villaData.host_id,
      villa_long: villaData.geo_long,
      villaAddress: villaData.area,
      villaCity: villaData.name,
      villaLandmark: villaData.building,
      cancellationPolicy: villaData.cancellation_policy,
      checkInTime: villaData.check_in_start_time,
      checkOutTime: villaData.check_out_time,
      damageDeposit: villaData.damage_deposit,
      thumbnail: thumbnail[0],
      prepayment: getGuestPrepaymentPercent(
        villaData.advance_percent,
        villaData.commmission
      ),
      taxFlag: villaData.is_tax_included,
    };
    navigate("/payment", { state: bookingData });
  };
  let bedroomdata = [];
  villaData.villarooms.forEach((room, index) => {
    let bedobject = {};
    bedobject.room_type = room.room_type;
    bedobject.room = [];
    room.villaroom_bed?.forEach((x) => {
      if (x.quantity > 0) {
        bedobject.room.push(x);
      }
    });
    bedroomdata.push(bedobject);
  });
  // setBedroomsState(bedroomdata)
  //console.log(villaData, "bedobject");
  return (
    <div className="flex justify-center font-sans font-Glory">
      <div className="flex lg:mx-auto  flex-wrap text-[16px] text-black  w-[90vw] bg-[#f1f1f1]  border-[1px] rounded-lg shadow-lg ">
        <div className="border-r-[1.5px] border-black sm-1/2 md:w-1/3 lg:w-[30%] ">
          <h3 className="text-center border-b-[1.5px] px-4 py-2 border-black font-bold text-lg mb-4 ">
            Villa Type
          </h3>
          <ul className="ml-20 py-2 mb-4">
            <li className="flex my-2 text-[18px]">
              <span className="mr-5">
                <i class="fa-solid fa-house"> </i> Entire Villa
              </span>{" "}
              <span className="mr-5">{villaData.number_of_bedrooms} BHK</span>{" "}
              <span className="mr-5">Max {maxPax} PAX</span>
            </li>
            <li className="flex my-2 text-[18px]">Area - {area} Sq.ft</li>
            <li className="font-bold my-2 text-[18px]">{villaData.total_rooms} Rooms Total</li>
            <li className="flex flex-row text-[15px] font-medium">
              Bedroom 1 : 1 double bed{" "}
              <img
                className="ml-4 scale-[1]"
                src="/images/icons/room types/bed.svg"
              ></img>
            </li>
            <li className="flex flex-row text-[15px] font-medium">
              Bedroom 2 : 2 double bed{" "}
              <img
                className="ml-4 scale-[1]"
                src="/images/icons/room types/bed.svg"
              ></img>{" "}
              <img
                className="ml-4 scale-[1]"
                src="/images/icons/room types/bed.svg"
              ></img>
            </li>
            <li className="flex flex-row text-[15px] font-medium">
              Bedroom 3 : 1 double bed{" "}
              <img
                className="ml-4 scale-[1]"
                src="/images/icons/room types/bed.svg"
              ></img>
            </li>
            <li className="flex flex-row text-[15px] font-medium">
              Bedroom 4 : 1 double bed{" "}
              <img
                className="ml-4 scale-[1]"
                src="/images/icons/room types/bed.svg"
              ></img>
            </li>
            <li className="flex flex-row text-[15px] font-medium">
              Bedroom 5 : 1 double bed{" "}
              <img
                className="ml-4 scale-[1]"
                src="/images/icons/room types/bed.svg"
              ></img>
            </li>
            <li className="flex flex-row text-[15px] font-medium">
              Bedroom 6 : 1 twin bed{" "}
              <img
                className="ml-4 scale-[1]"
                src="/images/icons/room types/twin bed.svg"
              ></img>
            </li>
            <li className="flex flex-row text-[15px] font-medium">
              Living room : 1 sofa bed{" "}
              <img
                className="ml-4 scale-[1]"
                src="/images/icons/room types/sofa.svg"
              ></img>
            </li>
            <li className="flex flex-row text-[15px] font-medium">
              Other spaces : 1 bunk bed{" "}
              <img
                className="ml-4 scale-[1]"
                src="/images/icons/room types/bunk bed.svg"
              ></img>
            </li>
            <li className="flex flex-row text-[15px] font-medium">
              Kitchen{" "}
              <img
                className="ml-4 scale-[1]"
                src="/images/icons/room types/kitchen.svg"
              ></img>
            </li>
            <li className="flex flex-row text-[15px] font-medium">
              7 Bathrooms{" "}
              <img
                className="ml-4 scale-[1]"
                src="/images/icons/room types/bathroom.svg"
              ></img>
            </li>
          </ul>
        </div>
        <div className="border-r-[1.5px] border-black  sm-1/2 md:w-1/3 lg:w-[30%] flex flex-col relative ">
          <h3 className="text-center font-bold text-lg mb-4 border-b-[1.5px] px-4 py-2 border-black">
            Total Adults and Children
          </h3>
          <div className="flex flex-row px-4 py-2 h-auto relative">
            <div className=" my-2 font-semibold w-[14%]">Adults</div>
            <div className="flex w-[59%]">
              <div className="grid grid-cols-9  justify-center h-auto">
                {[...Array(adults)].map((el, i) => {
                  return (
                    <div className="mx-1 text-[30px] font-semibold">
                      <i class="fa-solid fa-person"></i>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* <div className=" my-2 absolute right-4 font-semibold">
              {adultsCount}
            </div> */}
            <div className="flex my-2 mr-1 flex-row w-[27%] justify-right">
              <div
                className={activeClass}
                onClick={() => {
                  setAdults(Math.max(1, adults - 1));
                }}
              >
                -
              </div>
              <div className="text-[13px] font-semibold text-black mx-1 w-7 text-center">
                {adults}
              </div>
              <div
                className={pax < maxPax ? activeClass : disableClass}
                onClick={() => {
                  if (pax < maxPax) setAdults(adults + 1);
                }}
              >
                +
              </div>
            </div>
          </div>
          <div className="flex flex-row px-4 mb-16 py-4 h-auto">
            <div className="  my-2 font-semibold w-[14%]">Children</div>
            <div className="flex w-[59%] ml-2">
              <div className="grid grid-cols-9 justify-center h-auto">
                {[...Array(children)].map((el, i) => {
                  return (
                    <div className="ml-2 text-[26px] font-semibold">
                      <i class="fa-solid fa-child"></i>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="flex my-2 mr-1 flex-row w-[27%] justify-right">
              <div
                className={activeClass}
                onClick={() => {
                  setChildren(Math.max(0, children - 1));
                }}
              >
                -
              </div>
              <div className="text-[13px] font-semibold text-black mx-1 w-7 text-center">
                {children}
              </div>
              <div
                className={pax < maxPax ? activeClass : disableClass}
                onClick={() => {
                  if (pax < maxPax) setChildren(children + 1);
                }}
              >
                +
              </div>
            </div>
          </div>

          <div className="border-t border-black py-5 absolute bottom-0 left-5 flex w-[90%] font-bold">
            <div className="font-bold w-[90%] ">TOTAL CUMULATIVE PAX</div>
            <span className="w-[10%] ml-20">{pax}</span>
          </div>
        </div>
        <div className="border-r-[1.5px] border-black sm-1/2 md:w-1/3 lg:w-[25%] relative ">
          <div className="text-center font-bold text-lg mb-4 border-b-[1.5px] px-4 py-2 border-black ">
            Price
          </div>
          <div className="flex flex-col justify-between">
            <div className="">
              <ul className=" px-4 ">
                <div className="flex flex-row justify-end text-center">
                  <svg
                    width="70"
                    height="31"
                    viewBox="0 0 45 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M5.27053 0H40.9996C43.2088 0 44.9996 1.79086 44.9996 4V10.9732C44.9996 13.1823 43.2088 14.9732 40.9996 14.9732H5.09995C3.19803 14.9732 1.65621 13.4314 1.65621 11.5294V10.5454C1.65621 9.94622 1.34186 9.39102 0.828106 9.08276C-0.276035 8.42028 -0.276035 6.82006 0.828106 6.15758C1.34186 5.84932 1.65621 5.29412 1.65621 4.69498V3.61432C1.65621 1.61819 3.2744 0 5.27053 0ZM4.01986 9.19582C4.89006 9.19582 5.5955 8.49038 5.5955 7.62018C5.5955 6.74998 4.89006 6.04454 4.01986 6.04454C3.14966 6.04454 2.44422 6.74998 2.44422 7.62018C2.44422 8.49038 3.14966 9.19582 4.01986 9.19582Z"
                      fill="#232322"
                    />
                  </svg>
                  <h6 className="text-[#FDFE03] text-right absolute mt-[3px] mr-1">
                    12% off
                  </h6>
                </div>
                <div className="flex justify-end mt-1 ">
                  <div className="flex flex-row my-auto">
                    <svg
                      width="51"
                      height="11"
                      viewBox="0 0 51 11"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="absolute mt-[6px]"
                    >
                      <line
                        x1="1.80703"
                        y1="9.83866"
                        x2="49.8387"
                        y2="1.19297"
                        stroke="#FA0E0E"
                        stroke-opacity="0.8"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                    <h5 className="text-black opacity-70  mr-2 ">
                      ₹{parseInt(1.12 * price)}
                    </h5>
                  </div>
                  <h1 className="text-black text-[20px] font-semibold">
                    ₹{price} /-
                  </h1>
                </div>

                <li className="text-end mb-2">
                  +₹{calcTaxAmount(price)} TAX ({TAX_PERCENT}%)
                </li>
                {price_per_extra_person && (
                  <li className="text-end font-bold text-[15px] mt-6">
                    Price per extra Person: ₹{price_per_extra_person}/- <br />{" "}
                    <span className="text-end font-semibold text-[13px] mt-1">
                      (For PAX above {includedPax})
                    </span>
                  </li>
                )}

                {(breakfast || lunch || dinner) && (
                  <div className="flex flex-row justify-center mt-6">
                    <div className="w-1/3 justify-end text-end pr-1  text-green-700 font-semibold ">
                      Included :{" "}
                    </div>
                    <div className="w-2/3 flex flex-row justify-center">
                      {breakfast && (
                        <div className="text-center mx-2 text-green-600 font-semibold  ">
                          Breakfast
                        </div>
                      )}
                      {lunch && (
                        <div className="text-center mx-2 text-green-600 font-semibold  ">
                          Lunch
                        </div>
                      )}
                      {dinner && (
                        <div className="text-center mx-2 text-green-600 font-semibold  ">
                          Dinner
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </ul>
            </div>
          </div>
        </div>
        <div className="sm-1/2 lg:w-[15%]">
          <div className="flex flex-col items-center justify-center h-full">
            {availability ? (
              <>
                <div className="flex flex-col justify-center my-2">
                  <button
                    onClick={() => {
                      if (startDate && endDate) handleBookNow();
                    }}
                    className={` ${
                      startDate && endDate
                        ? "bg-green-600 hover:bg-green-700"
                        : "bg-gray-600 hover:cursor-not-allowed"
                    }   text-white py-2 px-4 text-[13px] font-semibold rounded-full border-2 border-green-600 transition-all`}
                  >
                    Book Now
                  </button>
                </div>

                {/* <div className="flex justify-center mb-3 mt-1">
                  <button className="bg-none  text-black py-2 px-4 text-[13px] font-semibold rounded-full border-[1px] border-black transition-all">
                    Add to cart
                  </button>
                </div> */}
                <div className="font-semibold text-[13px] text-red-600 text-center">
                  {(!startDate || !endDate) && (
                    <h1>Please select start date and end date!</h1>
                  )}
                </div>
              </>
            ) : (
              <div className="flex items-center justify-center min-h-[90px] px-2">
                <div className="sold-out-splash">
                  <span className="sold-out-splash__missed">You just missed it !!</span>
                  <span className="sold-out-splash__sold">Sold Out</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutDetails;
